import { EnumPersistenceStatus } from '../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { Double2D } from '../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { DiagramShape } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/DiagramShape';
import { LineShape } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/LineShape';
import { NodeShape } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { ShapeElement } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/ShapeElement';
import { BaseComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { EnumComponentType } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { IDEContext } from '../../../Product/IDE/IDEContext';
import { GuidHelper } from '../../../Product/IDE/Util/GuidHelper';
import { UniqueKeyManager } from '../../MD/UniqueKeyManager';

/** 元数据形状的创建工厂 */
export class MDShapeRepository {
  /** 创建图表 */
  public static createDiagramShape(component: BaseComponent): DiagramShape {
    const diagramShape = new DiagramShape();
    this.setShapeElement(diagramShape);
    diagramShape.componentId = component.designId;
    diagramShape.componentType = EnumComponentType[component.componentType];
    return diagramShape;
  }

  /**
   * 创建节点图形
   * @param diagram 图形形状
   * @param startX 左上角X坐标
   * @param startY 左上角Y坐标
   * @param elementType 图形对应的元数据的类型
   */
  public static createNodeShape(diagramShape: DiagramShape, startX: number, startY: number, elementType: string, isJoinDiagram: boolean): NodeShape {
    const shape = new NodeShape();
    this.setShapeElement(shape);
    shape.startPoint = new Double2D(startX, startY);
    shape.elementType = elementType;
    if (diagramShape !== null) {
      shape.diagram_ID = diagramShape.id;
      if (isJoinDiagram) {
        diagramShape.nodeShapes.push(shape);
      }
    }
    return shape;
  }

  /**
   * 创建线图形
   * @param diagram 图形形状
   * @param relationshipType 图形对应的元数据的类型
   */
  public static createLineShape(diagramShape: DiagramShape, relationshipType: string, isJoinDiagram: boolean): LineShape {
    const shape = new LineShape();
    this.setShapeElement(shape);
    shape.relationshipType = relationshipType;
    if (diagramShape !== null) {
      shape.diagram_ID = diagramShape.id;
      if (isJoinDiagram) {
        diagramShape.lineShapes.push(shape);
      }
    }
    return shape;
  }

  /** 设置图形基类的初始属性 */
  private static setShapeElement(shape: ShapeElement) {
    shape.id = UniqueKeyManager.instance.getUniqueKey();
    shape.createdBy = IDEContext.instance.curAccountInfo.accountId;
    shape.owner = IDEContext.instance.curUser.tenancy_ID;
    shape.designId = GuidHelper.getGuid();
    shape.persistenceStatus = EnumPersistenceStatus.Create;
  }
}
